<div class="white-right">
  <div class="flex-container">
    <div class="section">
      <div class="options-container">
        <div class="option">
          <div *ngIf="!isNotificationPermissionAllowedSignal()" class="notification warn">
            We see you have disabled notifications in your browser. You will need to open your
            <b>browser preferences</b> to change that.
          </div>

          <div *ngIf="isNotificationPermissionAllowedSignal()">
            <div class="option-inputs">
              <loop-setting-column name="Notifications" description="Enable to receive notifications">
                <loop-toggle-switch-control
                  [ngModel]="areNotificationsAllowedSignal()"
                  (ngModelChange)="onAllowNotificationToggle($event)"
                />
              </loop-setting-column>

              <div *ngIf="isRequestingPermissionSignal()" class="notification">
                Click <b>Allow</b> in your browser's pop-up to enable notifications. If the pop-up is not shown check
                your <b>browser preferences.</b>
              </div>

              <loop-setting-column
                name="Notification Sound"
                description="Play a sound when a notification is received."
              >
                <loop-toggle-switch-control
                  [(ngModel)]="notificationSettings.notificationSound"
                  (ngModelChange)="onNotificationChange($event)"
                />
              </loop-setting-column>

              <loop-setting-column
                *ngIf="notificationSettings.allowNotifications"
                name="Receive Notifications in the App"
                description="Notify me also while I am using the app"
              >
                <loop-toggle-switch-control
                  [(ngModel)]="notificationSettings.isNotifyWhenFocusedEnabled"
                  (ngModelChange)="onNotificationChange($event)"
                />
              </loop-setting-column>

              <ng-container *ngIf="areNotificationsAllowedSignal()">
                <div class="option-title">Loop can notify of the following:</div>

                <loop-setting-column
                  name="Private conversation"
                  description="Notify me when a new direct message is received"
                >
                  <loop-toggle-switch-control
                    [(ngModel)]="notificationSettings.notifications.chat"
                    (ngModelChange)="onNotificationChange($event)"
                  />
                </loop-setting-column>

                <loop-setting-column name="Email conversation" description="Notify me when a new email is received">
                  <loop-toggle-switch-control
                    [(ngModel)]="notificationSettings.notifications.email"
                    (ngModelChange)="onNotificationChange($event)"
                  />
                </loop-setting-column>

                <loop-setting-column
                  name="Team conversation"
                  description="Notify me when a new team message is received"
                >
                  <loop-toggle-switch-control
                    [(ngModel)]="notificationSettings.notifications.teamEmail"
                    (ngModelChange)="onNotificationChange($event)"
                  />
                </loop-setting-column>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
